// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"rigth-content_wrapper__2tjll","listSectionMobile":"rigth-content_listSectionMobile__3UqG2","listSection":"rigth-content_listSection__1G14v"};